import { inject, Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { concatMap, EMPTY, of, OperatorFunction, tap } from 'rxjs';

import { ToastService } from '@ps/core-overlay';

import {
  reportFormErrors,
  SaveGateOptions,
  saveGateForms,
} from '../../utils/survey-save-pipeline.helper';
import { gatherSurveyFormContext } from '../../utils/survey-form-context.helper';
import {
  overridesFromTrigger,
  toValidatedSurvey,
} from '../../utils/survey-save-validation.helper';
import { ValidatedSurveyForSave } from '../survey-save.pipeline.types';

// Validate stage: passes an existing, submittable survey; reports the first error otherwise.
@Injectable({ providedIn: 'root' })
export class SurveySaveValidateStage {
  private readonly _store = inject(Store);
  private readonly _toastService = inject(ToastService);

  public validate(
    gate: SaveGateOptions,
  ): OperatorFunction<Action, ValidatedSurveyForSave> {
    return (trigger$) =>
      trigger$.pipe(
        gatherSurveyFormContext(this._store),
        tap(({ audienceForm, launchForm, marginForm }) =>
          reportFormErrors(
            this._toastService,
            saveGateForms(audienceForm, launchForm, marginForm, gate),
          ),
        ),
        concatMap((context) =>
          toValidatedSurvey(
            context,
            gate,
            overridesFromTrigger(context.trigger),
          ).match({
            some: (validated) => of(validated),
            none: () => EMPTY,
          }),
        ),
      );
  }
}
